import React from 'react';
import { motion } from 'framer-motion';
import { AtomIcon, BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-background" data-id="element-82" data-mp="sa9slf0wlvx6">
      <div className="h-1 w-full bg-primary shadow-[0_0_16px_rgb(var(--color-primary)/0.8)]" aria-hidden="true" data-id="element-83" data-mp="ncq0bb7dfim8" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-84" data-mp="3d1s9sv56tfs2">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-primary/60 bg-surface px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-foreground shadow-glow" data-id="element-85" data-mp="381xjaspbqs7j">
          <AtomIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-86" data-mp="3e960lmzlrvex" /> {productBrand}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-87" data-mp="30iaweo01u2ho">
          <img src={productImage} alt="Hydrogen Energy & Fuel Cells Professional Edition: six volumes and five bonus resources covering fundamentals, production and electrolysis, storage and infrastructure, fuel cells, industrial applications and safety" className="mx-auto w-full drop-shadow-[0_24px_40px_rgba(0,191,255,0.25)]" data-id="element-88" data-mp="2qi0mpdd83d79" />
        </motion.div>

        <div className="mt-9" data-id="element-89" data-mp="s333380kgeuw">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-90" data-mp="s44hnmgsjjhd">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-91" data-mp="id9umfvq0fuv">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-primary/50 bg-surface px-3 py-2" data-id="element-92" data-mp="1b0nkju104b5h">
              <Icon className="h-3.5 w-3.5 text-primary-strong" aria-hidden="true" data-id="element-93" data-mp="162ufj4bfpn6s" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}